// extracted by mini-css-extract-plugin
export default {"container":"ServicesPage_container__9FkwB"};